module.exports = __webpack_public_path__ + "static/img/higrometro-1.c9c3e14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/higrometro-1.svg
// module id = U8ru
// module chunks = 0